import apiClient from './apiClient';

export const SAFETY_REPORTS_UPDATED_EVENT = 'safety-reports:updated';

export type SafetyReportStatus = 'open' | 'in_review' | 'resolved' | 'dismissed';
export type SafetyReportAction =
  | 'start_review' | 'dismiss' | 'resolve' | 'hide_profile'
  | 'deactivate_registration' | 'suspend_account';

export interface SafetyReportSummary {
  id: string;
  event_id: string | null;
  subject_type: 'attendee_profile' | 'ai_response';
  reported_user_id: string | null;
  category: string;
  status: SafetyReportStatus;
  created_at: string;
  updated_at: string;
}

export interface SafetyReportDetail extends SafetyReportSummary {
  evidence: {
    profile?: Record<string, string | null>;
    captured_at?: string;
    preceding_prompt?: string;
    response?: string;
    route?: string;
    generated_at?: string;
  };
  details: string | null;
  resolution_action: SafetyReportAction | null;
  resolved_at: string | null;
  actions: {
    id: string;
    action: SafetyReportAction;
    actor_id: string | null;
    note: string | null;
    created_at: string;
  }[];
}

export const safetyService = {
  list({ eventId, status, offset }: { eventId?: string; status?: SafetyReportStatus; offset?: number } = {}) {
    const query = new URLSearchParams();
    if (eventId) query.set('event_id', eventId);
    if (status) query.set('status', status);
    if (offset) query.set('offset', String(offset));
    return apiClient.get<SafetyReportSummary[]>(
      `/admin/safety/reports${query.size ? `?${query.toString()}` : ''}`,
    );
  },
  pendingCount(eventId?: string) {
    const query = eventId ? `?event_id=${encodeURIComponent(eventId)}` : '';
    return apiClient.get<{ count: number }>(`/admin/safety/reports/pending-count${query}`);
  },
  detail(reportId: string) {
    return apiClient.get<SafetyReportDetail>(`/admin/safety/reports/${encodeURIComponent(reportId)}`);
  },
  async act(reportId: string, action: SafetyReportAction, note: string) {
    const result = await apiClient.post<SafetyReportDetail>(
      `/admin/safety/reports/${encodeURIComponent(reportId)}/actions`,
      { action, note },
    );
    window.dispatchEvent(new Event(SAFETY_REPORTS_UPDATED_EVENT));
    return result;
  },
};
